import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/core/services/store'
import '@/core/filters/filters'
import ApiService from '@/core/services/api.service'
import { VERIFY_AUTH } from '@/core/services/store/auth.module'
import { RESET_LAYOUT_CONFIG } from '@/core/services/store/config.module'
import Notifications from 'vue-notification'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VueColorPicker from '@duoa/vue-color-picker'

Vue.config.productionTip = false

// Global 3rd party plugins
import 'popper.js'
import 'tooltip.js'
import PerfectScrollbar from 'perfect-scrollbar'
window.PerfectScrollbar = PerfectScrollbar
import ClipboardJS from 'clipboard'
window.ClipboardJS = ClipboardJS

// Vue 3rd party plugins
import i18n from '@/core/plugins/vue-i18n'
import '@/core/plugins/portal-vue'
import '@/core/plugins/bootstrap-vue'
import '@/core/plugins/perfect-scrollbar'
import '@/core/plugins/highlight-js'
import '@/core/plugins/inline-svg'
import '@/core/plugins/apexcharts'
import '@/core/plugins/treeselect'
import '@/core/plugins/metronic'
import '@mdi/font/css/materialdesignicons.css'
import '@/core/plugins/formvalidation'
import '@duoa/vue-color-picker/dist/vue-color-picker.css'

//
Vue.use(VueColorPicker)

// Moment
Vue.use(require('vue-moment'))

// Notifications
Vue.use(Notifications)

// API service init
ApiService.init()

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next)

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG)

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
